// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e0ba2cbe","455":"2686ceeb"}[chunkId] + ".chunk.js";
};